import React from "react";
import PropTypes from "prop-types";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import ReactMaskedInput from "./masked-input";
import Icon from "../elements/icon";
import ConditionalWrap from "../renderless/conditional-wrap";

const propTypes = {
  onChange: PropTypes.func,
  maskType: PropTypes.string,
  allowDecimal: PropTypes.bool,
  showIcon: PropTypes.bool,
  integerLimit: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconAlignment: PropTypes.oneOf(["align-left", "align-right"]),
};
const placeholderChars = {
  whitespace: "\u2000",
  underscore: "_",
};

const mask_config = {
  placeholderChar: placeholderChars.whitespace,
  guide: true,
  pipe: null,
  keepCharPositions: false,
  help: null,
  placeholder: null,
};

const getValueWithoutComma = val => {
  return val.replace(/,/g, "");
};

const getMask = ({ type = "number", allowDecimal = false, integerLimit = null }) => {
  // more options: https://github.com/text-mask/text-mask/tree/master/addons/#readme
  const config = {
    currency: {
      mask: createNumberMask({
        ...mask_config,
        prefix: "",
        allowDecimal,
        integerLimit,
      }),
      getValue: getValueWithoutComma,
      icon: <Icon icon="dollar" />,
    },
    percent: {
      getValue: getValueWithoutComma,
      mask: createNumberMask({
        ...mask_config,
        prefix: "",
        allowDecimal,
        integerLimit,
      }),
      icon: <Icon icon="percent" />,
    },
    number: {
      getValue: getValueWithoutComma,
      mask: createNumberMask({
        ...mask_config,
        prefix: "",
        allowDecimal,
        integerLimit,
      }),
      icon: () => null,
    },
  };
  return config[type];
};

const NumericInput = ({
  onChange,
  value,
  maskType,
  allowDecimal,
  integerLimit,
  showIcon,
  iconAlignment = "align-left",
  iconBackgroundColor,
  ...rest
}) => {
  const { mask, getValue, icon } = getMask({ type: maskType, allowDecimal, integerLimit });
  const style = value ? { backgroundColor: iconBackgroundColor } : {};

  return (
    <ConditionalWrap
      condition={showIcon}
      wrap={children => {
        return <div className="et--numeric-input--with-icon">{children}</div>;
      }}
    >
      {iconAlignment === "align-left" && showIcon && (
        <span style={style} className={`et--numeric-input--icon${value ? " is-active" : ""}`}>
          {icon}
        </span>
      )}
      <ReactMaskedInput value={value} mask={mask} onChange={val => onChange(getValue(val))} {...rest} />
      {iconAlignment === "align-right" && showIcon && (
        <span style={style} className={`et--numeric-input--icon${value ? " is-active" : ""}`}>
          {icon}
        </span>
      )}
    </ConditionalWrap>
  );
};

NumericInput.propTypes = propTypes;
NumericInput.displayName = "NumericInput";
export default NumericInput;
